import { useTranslation } from "react-i18next";
import { useFormik } from "formik";
import * as Yup from 'yup';
import { useState } from "react";

import NewPage from "../../../layouts/page/NewPage";
import Form from "./Form";
import MenuConfig from "../../../../constants/MenuConfig";
import Api from "../../../../constants/Api";
import { convertBooleanToStatus } from "../../../../utils/ConverterUtils";
import { getId, sendToApi } from "../../../../utils/ApiUtils";
import { ApiError } from "../../../components/Common/ApiError";
import { useNavigate } from "react-router-dom";

const CategoryNew = () => {

    const { t } = useTranslation();
    const [status, setStatus] = useState(true);
    const [entityData, setEntityData] = useState(null);
    const navigate = useNavigate();

    const validationSchema = Yup.object().shape({
        name: Yup.string()
            .max(50, t('validation.max_length', { max: 50 }))
            .required(t('validation.required.name')),
        dreGroup: Yup.object()
            .required(t('cash_flow.validation.required.dreGroup')).nullable(),
        description: Yup.string()
            .max(255, t('validation.max_length', { max: 255 }))
    });

    const formik = useFormik({
        initialValues: {
            name: '',
            dreGroup: null,
            description: ''
        },
        validationSchema,
        onSubmit: async (values) => {
            const data = {
                id: getId(entityData),
                name: values.name,
                dreGroup: values.dreGroup?.value,
                description: values.description,
                status: convertBooleanToStatus(status)
            };

            // Aciona a api
            sendToApi(Api.cash_flow.category, data, () => {
                if (entityData == null) {
                    formik.resetForm();
                } else {
                    navigate(MenuConfig.cash_flow.categories.route);
                }
            }, (error) => {
                ApiError(error);
                formik.setSubmitting(false);
            });
        }
    });

    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('cash_flow.label')}
                childMenu={t('cash_flow.categories')}
                activeMenu={t('new')}
                child={
                    <Form
                        status={status}
                        setStatus={setStatus}
                        formik={formik}
                        entityData={entityData}
                    />
                }
                setEntityData={setEntityData}
                path={Api.cash_flow.category}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.cash_flow.categories.route}
            />
        </>
    );
}

export default CategoryNew;